<template>
  <header class="text-center bg-blue-800 text-white p-4 mb mb-10">
    <div class="text-3xl md:text-5xl font-bold mb-3">
      <i class="fa fa-viruses"></i> Covid-19 Tracker
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
};
</script>
